import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import LocationmarkerIcon from 'icons/Locationmarker.icon';
import { MapValue } from 'models/Listing';
import useLocationMapper from 'router/data/useLocationMapper';

import './ListingLocation.styles.scss';
import './ListingLocation.styles.responsive.scss';

type ListingLocationProps = {
  className?: string;
  to?: string;
  industry: string;
  isUrgentListing?: boolean;
  locationPostcode?: string;
  location?: MapValue;
  dealLocation?: string;
};

const ListingLocation: React.FC<ListingLocationProps> = (props) => {
  const {
    className,
    to,
    industry,
    isUrgentListing,
    locationPostcode,
    location,
    dealLocation,
  } = props;

  const { locationLabelMapper } = useLocationMapper();

  const classes = classNames('listing-location', className);

  const content = useMemo(
    () => (
      <>
        <span>
          {isUrgentListing ? (
            <>
              <LocationmarkerIcon />
              {locationPostcode}
            </>
          ) : (
            locationLabelMapper[location?.state] || dealLocation
          )}
        </span>
        <span>{industry}</span>
      </>
    ),
    [
      dealLocation,
      industry,
      isUrgentListing,
      location?.state,
      locationLabelMapper,
      locationPostcode,
    ],
  );

  return to ? (
    <Link to={to} className={classes}>
      {content}
    </Link>
  ) : (
    <div className={classes}>{content}</div>
  );
};

export default ListingLocation;
